import { combineReducers } from 'redux';
// reducers
import app from './app_reducers';
import templates from './templates_reducers';
import pages from './pages_reducers';
import results from './results_reducers';
import widgets from './widgets_reducers';
import tools from './tools_reducers';
import modal from './modal_reducers';

// Reducer name should be the same as stores object
// Note that each of these reducers is managing its own part of the global state.
// The state parameter is different for every reducer, and corresponds to the part of the state it manages.
export const rootReducer = combineReducers({
    app,
    templates,
    pages,
    results,
    widgets,
    tools,
    modal,
});



// WEBPACK FOOTER //
// ./src/_app/quick_response/reducers/_root.js